import { useState } from 'react';

function FullStackModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Full-Stack Development",
      content: [
        "Overview of Full-Stack Development: Frontend vs Backend",
        "What is Full-Stack Development and Why is it Important?",
        "Client-Side vs Server-Side Technologies",
        "Introduction to Web Development: HTML, CSS, JavaScript",
        "The Full-Stack Development Workflow",
        "Tools and Technologies for Full-Stack Development",
        "Setting Up Your Development Environment"
      ]
    },
    {
      title: "Module 2: Frontend Basics - HTML, CSS, JavaScript",
      content: [
        "Introduction to HTML: Structure of Web Pages",
        "HTML Tags: Div, Span, Links, Lists, Forms",
        "CSS: Styling Elements, Colors, and Fonts",
        "CSS Layouts: Flexbox and Grid",
        "Responsive Web Design with CSS Media Queries",
        "JavaScript Basics: Variables, Data Types, Functions",
        "DOM Manipulation with JavaScript",
        "Event Handling in JavaScript",
        "Introduction to jQuery and Why Use It",
        "Making AJAX Requests with jQuery",
        "Bootstrap Framework: Creating Responsive Layouts"
      ]
    },
    {
      title: "Module 3: Frontend Projects",
      content: [
        "Project 1: Flip Card Clone using HTML, CSS, and JavaScript",
        "Project 2: Netflix Clone using HTML, CSS, and JavaScript",
        "Project 3: Weather App using JavaScript and APIs",
        "Project 4: Todo App with Local Storage and jQuery",
        "Responsive Web Design and Bootstrap in Projects"
      ]
    },
    {
      title: "Module 4: React Basics",
      content: [
        "What is React and Why Use It?",
        "Setting Up React with Create-React-App",
        "Understanding JSX in React",
        "Components, Props, and State in React",
        "Handling Events in React",
        "Building a Simple React Application",
        "Component Lifecycle in React",
        "Managing State with useState and useEffect Hooks",
        "React Router for Navigation",
        "Form Handling in React"
      ]
    },
    {
      title: "Module 5: Backend Basics with Node.js and Express",
      content: [
        "What is Node.js and How Does It Work?",
        "Setting Up a Node.js Project",
        "Creating a Basic Server with Node.js",
        "Introduction to Express.js",
        "Setting Up an Express Application",
        "Routing in Express.js",
        "Handling HTTP Requests (GET, POST, PUT, DELETE)",
        "Middleware in Express.js",
        "Working with APIs in Express.js"
      ]
    },
    {
      title: "Module 6: MongoDB and Database Management",
      content: [
        "What is MongoDB? Overview of NoSQL Databases",
        "Setting Up MongoDB with Node.js",
        "Creating a MongoDB Database and Collection",
        "CRUD Operations in MongoDB (Create, Read, Update, Delete)",
        "Introduction to Mongoose for Schema Definition",
        "Validating Data in MongoDB with Mongoose",
        "Querying MongoDB: Filtering and Sorting Data",
        "Handling Relationships in MongoDB (One-to-One, One-to-Many)",
        "Connecting Express with MongoDB for Persistent Data Storage"
      ]
    },
    {
      title: "Module 7: Full-Stack Development with MERN",
      content: [
        "Integrating React with Express and Node.js",
        "Connecting React with Backend APIs using Axios",
        "Building a CRUD Application with MERN Stack",
        "State Management with React and Backend Integration",
        "Authentication in MERN Stack using JWT",
        "Error Handling in MERN Stack",
        "Handling Asynchronous Operations in React with useEffect"
      ]
    },
    {
      title: "Module 8: Full-Stack Project 1: Doctor Appointment System",
      content: [
        "Overview of the Doctor Appointment System",
        "Frontend: Building Appointment Booking Form in React",
        "Backend: Setting up Express API for Appointment Data",
        "Storing Appointment Data in MongoDB",
        "User Authentication with JWT in React and Express",
        "Managing Appointments: Book, Update, and Cancel Appointments",
        "Connecting Frontend with Backend APIs using Axios",
        "Deploying the Doctor Appointment System to Heroku"
      ]
    },
    {
      title: "Module 9: Full-Stack Project 2: Railway Management Portal",
      content: [
        "Overview of the Railway Management Portal",
        "Frontend: Building Ticket Booking Interface in React",
        "Backend: Setting up Express API for Train Schedules and Bookings",
        "Managing Ticket Reservations in MongoDB",
        "Search and Filter Functionality for Train Schedules",
        "Payment Integration (Simulated for the project)",
        "Deploying the Railway Management Portal"
      ]
    },
    {
      title: "Module 10: Full-Stack Project 3: E-commerce Website",
      content: [
        "Overview of the E-commerce Website",
        "Frontend: Building Product Listings and Cart in React",
        "Backend: Creating APIs for Product Management with Express",
        "Handling User Authentication and Authorization",
        "Processing Payments (Simulated with Stripe)",
        "Managing Orders and Customer Data with MongoDB",
        "Implementing Checkout Process and Cart Functionality"
      ]
    },
    {
      title: "Module 11: Full-Stack Project 4: Blogging Platform",
      content: [
        "Overview of the Blogging Platform",
        "Frontend: Building Post Listing and User Profile in React",
        "Backend: Setting up API for Creating, Editing, and Deleting Posts",
        "User Authentication and Authorization",
        "Storing Blog Data and User Profiles in MongoDB",
        "Commenting and Rating System for Blog Posts",
        "Deploying the Blogging Platform to the Web"
      ]
    },
    {
      title: "Module 12: Final Project Deployment and Advanced Topics",
      content: [
        "Overview of Full-Stack Project Deployment",
        "Environment Variables and Configuration for Production",
        "Deploying Backend (Node/Express/MongoDB) on Heroku or AWS",
        "Deploying Frontend (React) on Netlify or Vercel",
        "Setting Up MongoDB Atlas for Cloud Database",
        "Using Docker for Containerization of Full-Stack Apps",
        "CI/CD Pipeline for Full-Stack Projects",
        "Security Best Practices for Full-Stack Applications",
        "Optimizing Full-Stack Apps for Performance and Scalability"
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Full-Stack Development Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px' }}>{item}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FullStackModule;
